module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sidebar1"
  }, [_c('p', {
    staticClass: "PT"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("“If You Break Your Leg, Don’t Come Running to Me!”")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "PST"
  }, [_vm._v("(Spring and Summer)")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51ae99aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1.vue
// module id = 72
// module chunks = 0